import { App } from 'vue';

const register = (app: App) => {
    // This variable will hold the reference to
    // document's click handler
    const handleOutsideClicks: Record<any, (this: Document, ev: Event) => any> = {};
    app.directive('closable', {
        created(el, binding, vnode) {
            // Here's the click/touchstart handler
            // (it is registered below)
            handleOutsideClicks[el] = function (e) {
                // Get the handler method name and the exclude array
                // from the object used in v-closable
                const { handler, exclude } = binding.value;
                // This variable indicates if the clicked element is excluded
                let clickedOnExcludedEl = false;
                exclude.forEach((refName: string) => {
                    // We only run this code if we haven't detected
                    // any excluded element yet
                    if (!clickedOnExcludedEl) {
                        // Get the element using the reference name
                        const excludedEl = (vnode as any).ctx.refs[refName];
                        // See if this excluded element
                        // is the same element the user just clicked on
                        clickedOnExcludedEl = excludedEl && excludedEl.contains(e.target as Element);
                    }
                });
                // We check to see if the clicked element is not
                // the dialog element and not excluded
                if (!el.contains(e.target) && !clickedOnExcludedEl) {
                    // If the clicked element is outside the dialog
                    // and not the button, then call the outside-click handler
                    // from the same component this directive is used in
                    handler();
                }
            };
            // Register click/touchstart event listeners on the whole page
            document.addEventListener('click', handleOutsideClicks[el]);
            document.addEventListener('touchstart', handleOutsideClicks[el]);
        },
        unmounted(el) {
            // If the element that has v-closable is removed, then
            // unbind click/touchstart listeners from the whole page
            document.removeEventListener('click', handleOutsideClicks[el]);
            document.removeEventListener('touchstart', handleOutsideClicks[el]);
        },
    });
};

export default register;
